import {environment} from "src/environments/environment";

export function isPublicWorkLink(url: URL): boolean {
  return (
    [new URL(environment.frontUrl).origin, "https://app.gemster.io"].includes(
      url.origin
    ) &&
    !url.username &&
    !url.password &&
    !url.hash &&
    url.href.length <= 2048 &&
    /^\/work\/(movies|series|animation|games|books|mangas|comics)\/[a-f\d]{24}(?:\/[^/]+)?$/i.test(
      url.pathname
    )
  );
}
